import React from "react";

/**
 * LT-32 G2 — persistent environment banner.
 *
 * Driven ENTIRELY by the `REACT_APP_ENV_LABEL` build-time env var — never
 * hardcoded — so the identical codebase deploys to production with the var
 * UNSET and renders nothing there. On staging the var is set (e.g. "STAGING")
 * and a thin amber bar pins to the top of every page so you can tell at a
 * glance which environment you are looking at.
 *
 * Pattern mirrors the app's other inline status banners (amber, mono, compact).
 */
const ENV_LABEL = (process.env.REACT_APP_ENV_LABEL || "").trim();

export default function EnvBanner() {
  if (!ENV_LABEL) return null;
  return (
    <div
      data-testid="env-banner"
      role="status"
      aria-label={`Environment: ${ENV_LABEL}`}
      style={{
        background: "#7A3E06",
        color: "#FDF6EC",
        textAlign: "center",
        padding: "3px 12px",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      {ENV_LABEL} · not production
    </div>
  );
}
